import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { deleteCommand } from "../../../redux/actions/commands.actions";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import { useSearchParams } from "react-router-dom";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";

const DeleteCommandModal: React.FC<ModalProps> = ({open, setOpen,object}) => {
    const searchParams = useSearchParams()[0];
    const command = object;

    const handleClose = () => {
      handleReset();
      setOpen(false);
    };

    const handleReset = () => {
      setSubmitted(false);
    };

    const dispatch = useDispatch<AppDispatch>();
    const { accessToken } = useSelector((state: RootState) => state.user);
    const { error, loading } = useSelector((state: RootState) => state.commands);

    const [submitted, setSubmitted] = useState(false);

    const handleDelete = async (e: React.FormEvent) => {
      e.preventDefault();
      setSubmitted(true);
      await dispatch(deleteCommand({command_id: command?.id, params: searchParams.toString()}));
    };

  const step = !submitted && !loading ? "confirm" : loading && !error ? "deleting" : error ? "error" : "success";

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={step === "deleting"}
      tone={step === "confirm" ? "warning" : step === "error" ? "error" : step === "success" ? "success" : undefined}
      title={
        step === "confirm" ? `Delete "${command?.title}"?`
        : step === "deleting" ? "Deleting…"
        : step === "error" ? "An error occurred"
        : "Command deleted"
      }
      actions={
        step === "confirm" ?
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleDelete} disabled={!accessToken}>Delete</button>
        </>
        : step === "error" ?
        <>
          <button className="btn" onClick={handleClose}>Close</button>
          <button className="btn btn-primary" onClick={handleReset}>Try again</button>
        </>
        : step === "success" ?
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
        : undefined
      }
    >
      {step === "confirm" ?
        <p>This action cannot be undone.</p>
        : step === "deleting" ?
        <ModalLoading/>
        : step === "error" ?
        <p>{error}</p>
        :
        <p>Command successfully deleted.</p>
      }
    </ModalShell>
  );
};

export default DeleteCommandModal;
